import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import SmoothScroll from "@/components/SmoothScroll";
import { CartProvider } from "@/context/CartContext";
import { WishlistProvider } from "@/context/WishlistContext";
import { AuthProvider } from "@/context/AuthContext";
import Home from "@/pages/Home";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ChangePassword from "@/pages/ChangePassword";
import Pos from "@/pages/pos/Pos";
import InstallPrompt from "@/components/InstallPrompt";

function App() {
  return (
    <AuthProvider>
      <WishlistProvider>
        <CartProvider>
          <BrowserRouter>
            <SmoothScroll>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin/cambiar-clave" element={<ChangePassword />} />
                <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/pos" element={<Pos />} />
              </Routes>
            </SmoothScroll>
          </BrowserRouter>
          <InstallPrompt />
          <Toaster
            position="bottom-center"
            toastOptions={{
              style: {
                background: "#2C2621",
                color: "#FDFBF7",
                border: "none",
                fontFamily: "Manrope, sans-serif",
              },
            }}
          />
        </CartProvider>
      </WishlistProvider>
    </AuthProvider>
  );
}

export default App;
